import { Outlet, createFileRoute } from '@tanstack/react-router';
import Footer from '@/components/layout/footer';

export const Route = createFileRoute('/(cleaner)/_registration')({
  component: LayoutRegistration,
});

function LayoutRegistration() {
  return (
    <div className="flex flex-col gap-4 p-6 md:p-10">
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-4xl mx-auto">
          <a
            href="#"
            className="flex items-center justify-center gap-2 font-medium mb-10"
          >
            <img
              src="/images/logo.png"
              alt="Logo"
              className="h-20 w-auto mb-2"
            />
          </a>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
